import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {useMediaQuery} from 'react-responsive';
import {TABLET_WIDTH} from 'helpers/stableValues';
import breadcrumbIcon from 'cms/helpers/icons/breadcrumb.svg';

const Breadcrump = ({breadcrump, color}) => {
  const isTablet = useMediaQuery({query: `(max-width: ${TABLET_WIDTH}px)`});
  const wrapperStyles = Object.assign({
    display: 'flex'
  },
  isTablet && {
    overflowX: 'auto',
    whiteSpace: 'nowrap'
  });

  return (
    <div style={wrapperStyles}>
      {
        breadcrump.map(({count, title, href, isLast}) => {
          const bcClass = classnames(`text-${color}`, {
            'opacity-mid': !isLast && color === 'white',
            'font-bold': isLast && color === 'dark'
          });
          return (
            <Fragment key={count}>
              {
                count === 0 ?
                  <a href={href} className={bcClass}>
                    <img
                      src={breadcrumbIcon}
                      alt={title}
                      title={title}
                      className="pb-1"
                      width='16px'
                    />
                  </a>
                  :
                  <a href={href} className={bcClass} dangerouslySetInnerHTML={{__html: title}} />
              }
              {
                !isLast &&
                  <span
                    className={`text-${color} opacity-mid icon icon-right-arrow-1 text-small mx-2`}
                    aria-hidden="true"
                  />
              }
            </Fragment>
          );
        })
      }
    </div>
  );
};

Breadcrump.propTypes = {
  breadcrump: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  color: PropTypes.string.isRequired
};

Breadcrump.defaultProps = {
  breadcrump: [],
  color: 'white'
};

export default Breadcrump;
